import * as React from "react";
import {connect} from "react-redux";
import {setListenForAnchorPoint, SetListenForAnchorPoint, setUseAnchors, SetUseAnchors} from "../actions";
import * as selectors from "../selectors";
import LocationalState, {AnchorPoint} from "../LocationalState";
import classNames = require("classnames");

interface TagProps {

}

interface DispatchProps {
    doSetUseAnchors: SetUseAnchors,
    doSetListenForAnchorPoint: SetListenForAnchorPoint,
}

interface StateProps {
    useAnchors: boolean,
    listenForAnchorPoint: AnchorPoint,
    startAnchorSet: boolean,
    endAnchorSet: boolean
}


type Props = TagProps & StateProps & DispatchProps;

const mapStateToProps = (state: LocationalState): StateProps => {
    return {
        useAnchors: selectors.useAnchors(state),
        listenForAnchorPoint: selectors.listenForAnchorPoint(state),
        startAnchorSet: selectors.startAnchorIsSet(state),
        endAnchorSet: selectors.endAnchorIsSet(state)
    };
};

const mapDispatchToProps: DispatchProps = ({
    doSetUseAnchors: setUseAnchors,
    doSetListenForAnchorPoint: setListenForAnchorPoint,

});

class Component extends React.Component<Props, {}> {

    render() {
        const {useAnchors, startAnchorSet, endAnchorSet, listenForAnchorPoint} = this.props;

        let toolClasses = classNames({
            "anchorsTool": true,
            "useAnchors": useAnchors
        });
        let startButtonClasses = classNames({
            "btn": true,
            "is-set": startAnchorSet
        });
        let endButtonClasses = classNames({
            "btn": true,
            "is-set": endAnchorSet
        });

        return (
            <div className={toolClasses}>
                <label>
                    <input type="checkbox" checked={useAnchors} onChange={() => this.toggleUseAnchors()}/> Bruk manuelle ankerpunkter for stedfestingen
                </label>
                <div className={"extended"}>
                    <p>
                        Angi ankerpunkter i nærheten av starten og slutten på vegobjektet eller vegen.
                    </p>

                    <div className={"anchorsTool--buttons"}>
                        <button className={startButtonClasses} onClick={() => this.listenForAnchorPoint(AnchorPoint.start)}>Startpunkt</button>
                        <button className={endButtonClasses} onClick={() => this.listenForAnchorPoint(AnchorPoint.end)}>Sluttpunkt</button>
                    </div>
                </div>
            </div>
        );
    }

    toggleUseAnchors() {
        this.props.doSetUseAnchors(!this.props.useAnchors);
    };

    listenForAnchorPoint(anchorPoint: AnchorPoint) {
        this.props.doSetListenForAnchorPoint(anchorPoint)
    }

}

export const AnchorsTool = connect(mapStateToProps, mapDispatchToProps)(Component);